import { render } from "./TransferAcc.vue?vue&type=template&id=05b327be"
import script from "./TransferAcc.vue?vue&type=script&lang=js"
export * from "./TransferAcc.vue?vue&type=script&lang=js"

import "./TransferAcc.vue?vue&type=style&index=0&id=05b327be&lang=less"
script.render = render

export default script